export { default as PDPAConsent } from './PDPAConsent';
export { initialPDPAInfoPayload } from './PDPAConsent.utils';
export type {
  ConsentPurposeType,
  ConsentPurposeDetail,
} from './PDPAConsent.model';
